module.exports = __webpack_public_path__ + "img/wtiogomark.27bcc861.png";